"use client"

import { cn } from '@/shared/utils/tw'
import { useRealtimeAgentStore, SearchStateType } from '@/shared/store/realtime-agent'

interface SearchStatusIndicatorProps {
  className?: string
}

/**
 * 검색 상태 표시 컴포넌트
 *
 * "인터넷에서 찾아보고 있어요..." → "검색 결과를 찾았어요!"
 */
export function SearchStatusIndicator({ className }: SearchStatusIndicatorProps) {
  const searchState = useRealtimeAgentStore((state) => state.searchState)
  const searchQuery = useRealtimeAgentStore((state) => state.searchQuery)

  if (searchState === 'idle') {
    return null
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-4 py-2",
        "bg-[rgba(50,52,56,0.5)] backdrop-blur-lg",
        "rounded-full",
        "text-white text-sm",
        "animate-fadeIn",
        className
      )}
    >
      {searchState === 'searching' && (
        <>
          <SearchingSpinner />
          <span>인터넷에서 찾아보고 있어요...</span>
        </>
      )}

      {searchState === 'completed' && (
        <>
          <CheckIcon />
          <span>검색 결과를 찾았어요!</span>
        </>
      )}
    </div>
  )
}

function SearchingSpinner() {
  return (
    <svg
      className="animate-spin h-4 w-4 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  )
}

function CheckIcon() {
  return (
    <svg
      className="h-4 w-4 text-green-400"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 13l4 4L19 7"
      />
    </svg>
  )
}

export default SearchStatusIndicator
